import SEOTestPage from '../../components/SEOTestPage';
import { SEO_TESTS } from '../../data/seoTestsConfig';
export default function SabahYorgunlukTestiPage() {
  return <SEOTestPage testConfig={SEO_TESTS['sabah-yorgunluk-testi']} />;
}
